<template>
  <div class="row mt-4 mb-5">
    <div class="col-12">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'assistedLivingCoachingNewAndActiveList' }"
              :class="{ active: $route.name === 'assistedLivingCoachingNewAndActiveList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Aktiv + Neu
          </router-link>
          <router-link
              :to="{ name: 'assistedLivingCoachingFinishedList' }"
              :class="{ active: $route.name === 'assistedLivingCoachingFinishedList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            In den letzten 60 Tagen abgeschlossen
          </router-link>
          <router-link
              :to="{ name: 'assistedLivingCoachingArchivedList' }"
              :class="{ active: $route.name === 'assistedLivingCoachingArchivedList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Archiv
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>